import React, { Component } from "react";
import {
  Paper, Button, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { addToCart } from "../../../../store/actions/cartActions";
import { GetProductDetails } from "../../../services";
import { Link } from "react-router-dom";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import { encryptId, decryptId } from "../../../../utils/crypto";
import "./index.css";

class Singleproduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: null,
      selectedVariants: [],
      totalMoney: 0,
      isOpen: false,
      photoIndex: 0,
      rpm: 350,
      stitchTime: 0,
      selectedImage: "",
      relatedProducts: [],
      designModalOpen: false,
      designs: [],
      selectedVariantId: null,
      loadingDesigns: false,
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    const pathParts = this.props.location.pathname.split("/");
    const lastParam = pathParts[pathParts.length - 1];

    let productId = null;

    // 🟡 Try decrypting
    const decrypted = decryptId(lastParam);

    if (decrypted) {
      // ✅ Already encrypted
      productId = decrypted;
    } else if (!isNaN(lastParam)) {
      // 🔴 Plain numeric ID → encrypt & replace URL
      const encrypted = encryptId(lastParam);

      this.props.history.replace(`/p/${encrypted}`);

      productId = lastParam; // use original ID for API call
    }

    if (!productId) {
      this.props.history.replace("/404");
      return;
    }

    const response = await GetProductDetails.getProductById(productId);

    if (response && response.success) {
      this.setState(
        {
          product: response.data,
          selectedImage: response.data.photo,
          relatedProducts: response.relatedProducts || [],
        },
        () => {
          this.calculateStitchTime(this.state.rpm);
        }
      );

      this.calculateStitchTime(this.state.rpm);
    }
  }

  // async componentDidUpdate(prevProps) {
  //   let url = window.location.href.split("/");
  //   let currentHash = url[url.length - 1];
  //   let currentProductId = decryptId(currentHash);

  //   let prevUrl = prevProps.location.pathname.split("/");
  //   let prevHash = prevUrl[prevUrl.length - 1];
  //   let previousProductId = decryptId(prevHash);

  //   if (!currentProductId || !previousProductId) return;

  //   // If the current product ID is different from the previous one, fetch the new product
  //   if (currentProductId !== previousProductId) {
  //     const response = await GetProductDetails.getProductById(currentProductId);
  //     if (response && response.success) {
  //       this.setState({
  //         product: response.data,
  //         selectedVariants: [],
  //         totalMoney: 0,
  //       });
  //     }
  //   }
  // }

  async componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const pathParts = this.props.location.pathname.split("/");
      const lastParam = pathParts[pathParts.length - 1];

      const productId = decryptId(lastParam);

      if (!productId) return;

      const response = await GetProductDetails.getProductById(productId);

      if (response?.success) {
        this.setState(
          {
            product: response.data,
            selectedImage: response.data.photo,
            relatedProducts: response.relatedProducts || [],
            selectedVariants: [],
            totalMoney: 0,
          },
          () => {
            this.calculateStitchTime(this.state.rpm);
          }
        );
      }
    }
  }


  getVariantDesigns = async (variant_id) => {

    try {

      this.setState({
        loadingDesigns: true,
        designModalOpen: true,
        designs: []
      });


      const response = await fetch(
        "https://jccreations.boutique/api/embroidery/variant-metadata",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            variant_id
          })
        }
      );


      const data = await response.json();


      if (data.success) {

        this.setState({
          designs: data.designs,
          selectedVariantId: variant_id
        });

      }


    } catch (error) {

      console.log(error);

    } finally {

      this.setState({
        loadingDesigns: false
      });

    }

  };


  calculateStitchTime = (rpm) => {
    const { product } = this.state;

    if (!product?.stitches) return;

    const stitchString = product.stitches.trim();
    let totalStitches = 0;

    // Case 1: Plain number
    if (!stitchString.includes(",")) {
      totalStitches = parseInt(stitchString) || 0;
    } else {
      const parts = stitchString.split(",");
      const back = parseInt(parts[0]?.split(" ")[1]) || 0;
      const hand = parseInt(parts[1]?.split(" ")[2]) || 0;
      totalStitches = back + hand * 2;
    }

    if (!totalStitches || !rpm) {
      this.setState({ stitchTime: "0 Minutes" });
      return;
    }

    const timeInMinutes = totalStitches / rpm;

    let formattedTime = "";

    if (timeInMinutes >= 1) {
      const hours = Math.floor(timeInMinutes / 60);
      const minutes = Math.round(timeInMinutes % 60);

      if (hours > 0) {
        formattedTime = `${hours} H ${minutes} M`;
      } else {
        formattedTime = `${minutes} Minute${minutes !== 1 ? "s" : ""}`;
      }
    } else {
      const seconds = Math.round(timeInMinutes * 60);
      formattedTime = `${seconds} Second${seconds !== 1 ? "s" : ""}`;
    }

    this.setState({ stitchTime: formattedTime });
  };

  handleRPMChange = (event) => {
    const rpm = parseInt(event.target.value);
    this.setState({ rpm }, () => this.calculateStitchTime(rpm));
  };

  handleCheckboxChange = (event, variant) => {
    const { checked } = event.target;
    this.setState((prevState) => {
      const selectedVariants = checked
        ? [...prevState.selectedVariants, variant]
        : prevState.selectedVariants.filter((v) => v.id !== variant.id);

      const totalMoney = selectedVariants.reduce(
        (acc, curr) => acc + curr.variantPrice,
        0,
      );
      return {
        selectedVariants, totalMoney, selectedVariantId: checked
          ? variant.id
          : selectedVariants.length
            ? selectedVariants[0].id
            : null,
      };
    });
  };

  handleAddToCart = () => {
    if (this.state.selectedVariants.length === 0) {
      alert(
        "Please select at least one machine variant before adding to cart.",
      );
      return;
    }

    this.props.addToCart(this.state.product, this.state.selectedVariants); // Pass selectedVariants
  };

  handleGoBack = () => {
    window.history.back(); // Go back to the previous page
  };

  handleShare = () => {
    const { product } = this.state;
    const shareData = {
      title: product?.name,
      text: `Check out this amazing product: ${product?.name}`,
      url: window.location.href,
    };

    if (navigator.share) {
      navigator
        .share(shareData)
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else {
      // Fallback: Copy the URL to clipboard
      navigator.clipboard.writeText(window.location.href);
      alert("URL copied to clipboard!");
    }
  };

  // Handle lightbox open
  openLightbox = (index) => {
    this.setState({ isOpen: true, photoIndex: index });
  };

  render() {
    const { product, totalMoney, isOpen, photoIndex } = this.state;
    const images = [product?.photo]; // Array of images to display in the lightbox

    // Split the tags into an array
    const tagsArray = product?.tags.split(",").map((tag) => tag.trim());

    const hasVariants =
      product?.productvariants && product.productvariants.length > 0;

    const sortedVariants =
      product?.productvariants
        ? [...product.productvariants].sort((a, b) =>
          a.variantName.localeCompare(b.variantName)
        )
        : [];

    const firstVariantId = sortedVariants[0]?.id;


    return (
      <div>
        <section className="pt-3 pb-3 page-info section-padding border-bottom bg-white single-product-header-bk">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-8 col-md-6 d-flex align-items-center">
                <a href="/">
                  <strong>
                    <span className="mdi mdi-home" /> Home
                  </strong>
                </a>
                <span className="mdi mdi-chevron-right" />{" "}
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  Product
                </a>
              </div>
              <div className="col-4 col-md-3 text-md-end d-flex justify-content-end">
                <Button
                  variant="contained"
                  className="back-btn goback"
                  onClick={this.handleGoBack}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ marginRight: "5px" }}
                  />{" "}
                  Back
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="shop-single section-padding pt-3 px-3">
          <div className="container">
            {product ? (
              <div className="row">
                <div className="col-md-6">
                  <div className="shop-detail-left">
                    <Paper className="shop-detail-slider">
                      <div>
                        <img
                          loading="lazy" // Lazy load images
                          crossOrigin="anonymous"
                          src={this.state.selectedImage || product.photo}
                          className="img-fluid img-center"
                          alt={product.name}
                          style={{ borderRadius: "15px", cursor: "zoom-in" }}
                          onClick={() => this.openLightbox(0)} // Open lightbox on image click
                        />
                      </div>
                    </Paper>
                    <div className="related-products-demo">
                      <h5>Related Products</h5>

                      <div className="related-products-row">
                        {this.state.relatedProducts.map((item) => (
                          <div
                            key={item.id}
                            className="related-thumb"
                            title={item.name}
                            onClick={() => {
                              this.props.history.push(`/p/${encryptId(item.id)}`);
                            }}
                          >
                            <img
                              loading="lazy"
                              src={item.photo}
                              alt={item.name}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                    <h5>
                      Tags:{" "}
                      {tagsArray
                        .map((tag, index) => (
                          <Link
                            key={index}
                            to={`/tagsearch/${tag}`}
                            className="tag-link"
                          >
                            {tag}
                          </Link>
                        ))
                        .reduce((prev, curr) => [prev, ", ", curr])}
                    </h5>
                  </div>
                  <Paper
                    elevation={3}
                    style={{
                      padding: "20px",
                      marginTop: "20px",
                      borderRadius: "12px",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "2px solid #0077cc",
                        paddingBottom: "8px",
                        marginBottom: "15px",
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span role="img" aria-label="thread">
                          🧵
                        </span>{" "}
                        Stitch Details (Back + Hands)
                      </h3>
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                      <label style={{ fontWeight: "bold" }}>
                        Embroidery Speed:{" "}
                        <span style={{ color: "#0077cc" }}>
                          {this.state.rpm} RPM
                        </span>
                      </label>
                      <input
                        type="range"
                        min="350"
                        max="1000"
                        step="50"
                        value={this.state.rpm}
                        onChange={(e) => {
                          const rpm = parseInt(e.target.value);
                          this.setState({ rpm });
                          this.calculateStitchTime(rpm);
                        }}
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          accentColor: "#0077cc",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        fontSize: "17px",
                        background: "#e3f2fd",
                        padding: "12px",
                        borderRadius: "8px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#0d47a1",
                        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                      }}
                    >
                      Estimated Time: {this.state.stitchTime}
                    </div>
                  </Paper>

                  <br />
                </div>
                <div className="col-md-6">
                  <div className="shop-detail-right">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <h3 style={{ margin: 0 }}>Product Details</h3>
                      <span
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "20px",
                          background:
                            "linear-gradient(90deg, #FFA500, #FF4500)", // orange to red gradient
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                        onClick={this.handleShare}
                      >
                        <span style={{ marginRight: "5px" }}>Share</span>{" "}
                        <i className="mdi mdi-share" />{" "}
                      </span>
                    </div>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Product Name</td>
                          <td>{product.name}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Dimensions</td>
                          <td>
                            {product.height ? (
                              product.height.includes(",") ? (
                                <>
                                  <div>
                                    <strong>Height:</strong>{" "}
                                    {product.height.split(",")[0].split(" ")[1]}{" "}
                                    inch
                                  </div>
                                  <div>
                                    <strong>Width:</strong>{" "}
                                    {product.height.split(",")[1].split(" ")[2]}{" "}
                                    inch
                                  </div>
                                </>
                              ) : (
                                <div>{product.height}</div>
                              )
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td style={{ fontWeight: "bold" }}>Stitch Details</td>
                          {/* <td>{product.stitches}</td> */}
                          <td>
                            {product.stitches ? (
                              product.stitches.includes(",") ? (
                                <>
                                  <div>
                                    <strong>Back:</strong>{" "}
                                    {
                                      product.stitches
                                        .split(",")[0]
                                        .split(" ")[1]
                                    }
                                  </div>
                                  <div>
                                    <strong>Hand:</strong>{" "}
                                    {
                                      product.stitches
                                        .split(",")[1]
                                        .split(" ")[2]
                                    }
                                  </div>
                                </>
                              ) : (
                                <div>{product.stitches}</div>
                              )
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* <div>
                      <h3>Select a Machine</h3>
                      <h3>₹{totalMoney}</h3>
                      {product &&
                        product.productvariants &&
                        product.productvariants
                          .slice() // Create a shallow copy of the array
                          .sort((a, b) =>
                            a.variantName.localeCompare(b.variantName)
                          ) // Sort by variant name in ascending order
                          .map((variant) => (
                            <div
                              key={variant.id}
                              className="custom-control custom-checkbox"
                            >
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`variantCheck${variant.id}`}
                                value={variant.variantPrice}
                                onChange={(e) =>
                                  this.handleCheckboxChange(e, variant)
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`variantCheck${variant.id}`}
                              >
                                {variant.variantName} (₹{variant.variantPrice})
                              </label>
                            </div>
                          ))}
                            <button
                      type="button"
                      className="btn btn-secondary btn-lg"
                      onClick={this.handleAddToCart}
                      disabled={this.state.selectedVariants.length === 0}
                    >
                      <i className="mdi mdi-cart-outline" /> Add To Cart
                    </button>
                    </div> */}
                    <div>
                      {hasVariants ? (
                        <>
                          <h3>Select a Machine</h3>
                          <h3>₹{totalMoney}</h3>

                          {product.productvariants
                            .slice()
                            .sort((a, b) =>
                              a.variantName.localeCompare(b.variantName),
                            )
                            .map((variant) => (
                              <div
                                key={variant.id}
                                className="custom-control custom-checkbox"
                              >
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={`variantCheck${variant.id}`}
                                  value={variant.variantPrice}
                                  onChange={(e) =>
                                    this.handleCheckboxChange(e, variant)
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={`variantCheck${variant.id}`}
                                >
                                  {variant.variantName} (₹{variant.variantPrice}
                                  )
                                </label>

                              </div>
                            ))}
                          <button
                            className="preview-design-btn"
                            onClick={() =>
                              this.getVariantDesigns(
                                this.state.selectedVariantId || sortedVariants[0]?.id
                              )
                            }
                          >
                            ⚡ Preview Embroidery Designs
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-lg mt-3"
                            onClick={this.handleAddToCart}
                            disabled={this.state.selectedVariants.length === 0}
                          >
                            <i className="mdi mdi-cart-outline" /> Add To Cart
                          </button>
                        </>
                      ) : (
                        <div className="coming-soon-box">
                          <div className="coming-soon-content">
                            <div className="emoji">🚧</div>
                            <h3>Item is available in Combo offer.</h3>
                            <Link to="/p/2773">
                              <button className="buy-combo-btn">
                                Buy the Combo at just ₹99
                              </button>
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>

                    <h6
                      className="mb-3 mt-4"
                      style={{ color: "black", fontWeight: "bold" }}
                    >
                      Product Description
                    </h6>

                    <div className="pdct-dts-1 short-desc">
                      {product.sortDesc}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              "Loading..."
            )}
          </div>
        </section>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
            imageCrossOrigin="anonymous"
          />
        )}
        <Dialog
          open={this.state.designModalOpen}
          onClose={() =>
            this.setState({
              designModalOpen: false,
            })
          }
          maxWidth={false}
          PaperProps={{
            className: "design-preview-modal",
            style: {
              width: "850px",
              maxWidth: "90vw",
              maxHeight: "85vh",
              borderRadius: "18px",
              overflow: "hidden",
              overflowY: "auto",
              padding: "20px 24px",
            },
          }}
        >
          <DialogTitle className="design-preview-header">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <h2
                  style={{
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontWeight: 700,
                  }}
                >
                  <i className="mdi mdi-eye-outline" />
                  What you'll get with this design
                </h2>

                <h3
                  style={{
                    marginTop: "14px",
                    marginBottom: 0,
                    fontSize: "28px",
                    fontWeight: 700,
                    color: "#222",
                    lineHeight: "36px",
                  }}
                >
                  {product?.name || ""}
                </h3>
              </div>

              <i
                className="mdi mdi-close"
                style={{
                  cursor: "pointer",
                  fontSize: 28,
                }}
                onClick={() =>
                  this.setState({
                    designModalOpen: false,
                  })
                }
              />
            </div>
          </DialogTitle>

          <DialogContent className="design-preview-content">

            {/* Information Card 1 */}

            <div className="preview-info success">

              <i className="mdi mdi-information-outline" />

              <div>

                <strong>These are live previews</strong> extracted directly from the ZIP
                embroidery package.

                <br />

                You can inspect stitches, color stops, trims and design dimensions
                before purchasing.

              </div>

            </div>

            {/* Information Card 2 */}

            <div
              className="preview-info warning"
              style={{
                marginTop: 15,
              }}
            >

              <i className="mdi mdi-information-outline" />

              <div>

                Embroidery preview details are extracted directly from the original design file, including stitch count, color changes, trims, and dimensions. Actual embroidery output may vary slightly depending on your machine model and software.

              </div>

            </div>

            {/* Package */}

            <div
              style={{
                marginTop: 25,
                marginBottom: 20,
              }}
            >
              <h3
                style={{
                  marginBottom: 5,
                  fontWeight: 700,
                }}
              >
                Package :{" "}
                {
                  product?.productvariants?.find(
                    (v) => v.id === this.state.selectedVariantId
                  )?.variantName ||
                  product?.productvariants?.[0]?.variantName ||
                  "-"
                }
              </h3>

              <span
                style={{
                  color: "#777",
                }}
              >
                {this.state.designs.length} design files included
              </span>
            </div>

            {this.state.loadingDesigns ? (
              <div
                style={{
                  padding: 60,
                  textAlign: "center",
                }}
              >
                <i
                  className="mdi mdi-loading mdi-spin"
                  style={{
                    fontSize: 40,
                    color: "#ff9800",
                  }}
                />

                <h4>Loading Designs...</h4>
              </div>
            ) : (
              this.state.designs.map((design, index) => (
                <Paper
                  key={index}
                  elevation={0}
                  className="design-card"
                >
                  <div className="design-image">

                    <img
                      src={design.previewPngUrl}
                      alt={design.designName}
                    />

                  </div>

                  <div className="design-details">

                    <span className="format-badge">
                      {design.extension}
                    </span>



                    <div className="design-meta">

                      <div className="design-stats">

                        <span>
                          <i className="mdi mdi-needle" />
                          {design.stitchCount?.toLocaleString()} stitches
                        </span>

                        <span>
                          <i className="mdi mdi-palette" />
                          {design.colorCount} colors
                        </span>

                        <span>
                          <i className="mdi mdi-content-cut" />
                          {design.trimCount} trims
                        </span>

                      </div>

                      <div className="design-size">

                        <i className="mdi mdi-ruler" />

                        {design.width} × {design.height} mm

                        ({(design.width / 25.4).toFixed(2)} × {(design.height / 25.4).toFixed(2)} in)

                      </div>

                    </div>

                  </div>
                </Paper>
              ))
            )}
          </DialogContent>

          <DialogActions>

            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                this.setState({
                  designModalOpen: false,
                })
              }
            >
              Close
            </Button>

          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default connect(null, { addToCart })(Singleproduct);
